import * as toolkitRaw from '@reduxjs/toolkit';
const { createSlice } = toolkitRaw.default ?? toolkitRaw;

// ----------------------------------------------------------------------

const initialState = {
  loading: {},
  summary: null,
  currencyList: [],

  withdrawInfo: {
   network: null,
    address: '',
    amount: ''
  },
  amountVisible: true
};

const slice = createSlice({
  name: 'assets',
  initialState,
  reducers: {
    startLoading(state, { payload: type }) {
      const loading = state.loading;
      loading[type] = true;
      state.loading = { ...loading };
    },
    stopLoading(state, { payload: type }) {
      const loading = state.loading;
      loading[type] = false;
      state.loading = { ...loading };
    },
    setWithdrawInfo(state, { payload }) {
     state.withdrawInfo = {...payload}
    },
    setAmountVisible(state, { payload }) {
      state.amountVisible = payload
    }
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  stopLoading,
  setWithdrawInfo,
  setAmountVisible
} = slice.actions;

// ----------------------------------------------------------------------
